import { useQuery, useSubscription } from "@apollo/react-hooks";
import { useRecoilValue } from "recoil";
import {
  MY_HR_CONTRACTS_SUBSCRIPTION,
  MY_HR_GET_CONTRACTS_BY_EMPLOYEE_BY_PERIOD,
} from "my-hr/graphql";
import { useOcPolling } from "oc/hooks";
import { twoFaVerificationPendingState } from "oc/states";

export const useMyHrContractsByEmployeeByPeriod = ({
  employee,
  startDate,
  endDate,
}: {
  employee: string; // Replace 'string' with the correct type if different
  startDate: string; // Replace 'string' with the correct type if different
  endDate: string; // Replace 'string' with the correct type if different
}) => {
  const twoFaVerificationPending = useRecoilValue(twoFaVerificationPendingState);

  const { data, loading, error, refetch } = useQuery(
    MY_HR_GET_CONTRACTS_BY_EMPLOYEE_BY_PERIOD,
    {
      fetchPolicy: "cache-and-network",
      skip: !employee || twoFaVerificationPending, // Skip during 2FA flow
      pollInterval: useOcPolling(1000 * 60),
      variables: { employee, startDate, endDate },
    },
  );

  if (error) {
    console.log({
      component: "useContractsByEmployeeByPeriod",
      errorDescription:
        "Error occured when fetch data with MY_HR_GET_CONTRACTS_BY_EMPLOYEE_BY_PERIOD query",
      error: error,
    });
  }

  const { error: subscriptionError } = useSubscription(
    MY_HR_CONTRACTS_SUBSCRIPTION,
    {
      onData: () => {
        refetch();
      },
    },
  );

  if (subscriptionError) {
    console.log({
      component: "useContractsByEmployeeByPeriod",
      errorDescription:
        "Error occured when subscribe data with MY_HR_CONTRACTS_SUBSCRIPTION query",
      error: error,
    });
  }

  return {
    data: data?.contractsByEmployeeByPeriod || [],
    loading,
    error,
  };
};

export default useMyHrContractsByEmployeeByPeriod;
